export const API_URL =
  'https://clouderrorreporting.googleapis.com/v1beta1/projects/';
